// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var DOM__Event$SmartcutsMacros = require("../DOM__Event.bs.js");
var InputLabel$SmartcutsMacros = require("./shared/InputLabel.bs.js");
var ClickCommand$SmartcutsMacros = require("./ClickCommand.bs.js");
var SelectorWithSemantic$SmartcutsMacros = require("../SelectorWithSemantic.bs.js");
var Selection__InputCursor$SmartcutsMacros = require("../Selection/Selection__InputCursor.bs.js");
var InputCursorWithSemantics$SmartcutsMacros = require("./shared/InputCursorWithSemantics.bs.js");
var SelectionSemantics__InputCursorSemantics$SmartcutsMacros = require("../SelectionSemantics/SelectionSemantics__InputCursorSemantics.bs.js");
var DomElementIdentifierPaired__WithInputCursor$SmartcutsMacros = require("../DomElementIdentifierPaired__WithInputCursor.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "domElementIdentifierWithCursor",
                DomElementIdentifierPaired__WithInputCursor$SmartcutsMacros.t_encode(v.domElementIdentifierWithCursor)
              ],
              [
                "positionRelToElement",
                DOM__Event$SmartcutsMacros.PositionRelToElement.t_encode(v.positionRelToElement)
              ],
              [
                "eventSrc",
                Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Recording.eventSrc_encode, v.eventSrc)
              ],
              [
                "label",
                Decco.optionToJson(InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_encode, v.label)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var domElementIdentifierWithCursor = DomElementIdentifierPaired__WithInputCursor$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithCursor"), null));
  if (domElementIdentifierWithCursor.TAG === /* Ok */0) {
    var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElement.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
    if (positionRelToElement.TAG === /* Ok */0) {
      var eventSrc = Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Recording.eventSrc_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventSrc"), null));
      if (eventSrc.TAG === /* Ok */0) {
        var label = Decco.optionFromJson(InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
        if (label.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    domElementIdentifierWithCursor: domElementIdentifierWithCursor._0,
                    positionRelToElement: positionRelToElement._0,
                    eventSrc: eventSrc._0,
                    label: label._0
                  }
                };
        }
        var e = label._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".label" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = eventSrc._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".eventSrc" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = positionRelToElement._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".positionRelToElement" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = domElementIdentifierWithCursor._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".domElementIdentifierWithCursor" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function stringify(param) {
  return "cursor";
}

var Recording = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "inputCursorWithSemantics",
                InputCursorWithSemantics$SmartcutsMacros.t_encode(v.inputCursorWithSemantics)
              ],
              [
                "positionRelToElement",
                DOM__Event$SmartcutsMacros.PositionRelToElement.t_encode(v.positionRelToElement)
              ],
              [
                "label",
                Decco.optionToJson(InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_encode, v.label)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var inputCursorWithSemantics = InputCursorWithSemantics$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "inputCursorWithSemantics"), null));
  if (inputCursorWithSemantics.TAG === /* Ok */0) {
    var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElement.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
    if (positionRelToElement.TAG === /* Ok */0) {
      var label = Decco.optionFromJson(InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
      if (label.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  inputCursorWithSemantics: inputCursorWithSemantics._0,
                  positionRelToElement: positionRelToElement._0,
                  label: label._0
                }
              };
      }
      var e = label._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".label" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = positionRelToElement._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".positionRelToElement" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = inputCursorWithSemantics._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".inputCursorWithSemantics" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$1(param) {
  return "{inputCursorWithSemantics: {cursor, semantics: [" + (SelectionSemantics__InputCursorSemantics$SmartcutsMacros.stringify(param.inputCursorWithSemantics.semantics) + "], positionRelToElement}");
}

function fromRecordingCommandValue(param) {
  var inputCursor = param.domElementIdentifierWithCursor.inputCursor;
  var semantics = SelectionSemantics__InputCursorSemantics$SmartcutsMacros.ofInputCursor(inputCursor);
  return {
          inputCursorWithSemantics: {
            inputCursor: Selection__InputCursor$SmartcutsMacros.ForNonRecording.fromRecording(inputCursor),
            semantics: semantics
          },
          positionRelToElement: param.positionRelToElement,
          label: param.label
        };
}

function getInputIdentifier(param) {
  return "click:" + Selector$SmartcutsMacros.stringify(undefined, false, param.inputCursorWithSemantics.inputCursor.domElementRepresentation);
}

var Authoring = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1,
  fromRecordingCommandValue: fromRecordingCommandValue,
  getInputIdentifier: getInputIdentifier
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "selectorWithSemantic",
                SelectorWithSemantic$SmartcutsMacros.t_encode(SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.t_encode, v.selectorWithSemantic)
              ],
              [
                "positionRelToElement",
                DOM__Event$SmartcutsMacros.PositionRelToElement.t_encode(v.positionRelToElement)
              ],
              [
                "label",
                Decco.optionToJson(InputLabel$SmartcutsMacros.t_encode, v.label)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selectorWithSemantic = SelectorWithSemantic$SmartcutsMacros.t_decode(SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectorWithSemantic"), null));
  if (selectorWithSemantic.TAG === /* Ok */0) {
    var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElement.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
    if (positionRelToElement.TAG === /* Ok */0) {
      var label = Decco.optionFromJson(InputLabel$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
      if (label.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  selectorWithSemantic: selectorWithSemantic._0,
                  positionRelToElement: positionRelToElement._0,
                  label: label._0
                }
              };
      }
      var e = label._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".label" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = positionRelToElement._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".positionRelToElement" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = selectorWithSemantic._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selectorWithSemantic" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromAuthoringCommandValue(param) {
  var match = param.inputCursorWithSemantics;
  return {
          selectorWithSemantic: {
            selector: match.inputCursor.domElementRepresentation,
            semantic: Caml_array.get(match.semantics, 0)
          },
          positionRelToElement: param.positionRelToElement,
          label: Belt_Option.map(param.label, InputLabel$SmartcutsMacros.fromRecordingAndAuthoring)
        };
}

function selectorGet(param) {
  return [param.selectorWithSemantic.selector];
}

function stringify$2(param) {
  return "{selectorWithSemantic: " + (SelectorWithSemantic$SmartcutsMacros.stringify(SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.toHumanReadable, param.selectorWithSemantic) + ", positionRelToElement}");
}

var Playback = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  fromAuthoringCommandValue: fromAuthoringCommandValue,
  selectorGet: selectorGet,
  stringify: stringify$2
};

var CommandValue = {
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

function fromAuthoringCommandValue$1(authoringCommandValue) {
  var inputLabel = authoringCommandValue.label;
  if (inputLabel !== undefined && inputLabel.labels.length !== 0) {
    return {
            inputLabel: inputLabel,
            selectedLabelIndex: 0
          };
  }
  
}

function isDynamic(param) {
  return Belt_Option.isNone(param.selectedLabelIndex);
}

function applyToAuthoringCommandValueToGetPlaybackCommandValue(commandValue, param) {
  var match = param.inputLabel;
  var labels = match.labels;
  var sharedRootDepth = match.sharedRootDepth;
  var init = fromAuthoringCommandValue(commandValue);
  return {
          selectorWithSemantic: init.selectorWithSemantic,
          positionRelToElement: init.positionRelToElement,
          label: Belt_Option.map(Belt_Option.flatMap(param.selectedLabelIndex, (function (index) {
                      return Belt_Array.get(labels, index);
                    })), (function (param) {
                  return {
                          selector: param.selector,
                          labelText: param.labelText,
                          sharedRootDepth: sharedRootDepth
                        };
                }))
        };
}

var AuthoringConfig = {
  fromAuthoringCommandValue: fromAuthoringCommandValue$1,
  isDynamic: isDynamic,
  applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue
};

exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
/* Selector-SmartcutsMacros Not a pure module */
